import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ChevronDown } from "lucide-react";

const lines = ["THE MARY", "MANZUR", "EXPERIENCE"];

export default function Hero({ active, reduce }) {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
    const y = useTransform(scrollYProgress, [0, 1], [0, reduce ? 0 : 180]);
    const opacity = useTransform(scrollYProgress, [0, 0.85], [1, 0]);

    return (
        <section
            ref={ref}
            data-testid="hero-section"
            className="relative flex min-h-[100svh] flex-col items-center justify-center px-6 text-center"
        >
            <motion.div style={{ y, opacity }} className="relative z-[1]">
                <motion.p
                    className="eyebrow-label mb-8"
                    initial={{ opacity: 0, y: 14 }}
                    animate={active ? { opacity: 1, y: 0 } : {}}
                    transition={{ delay: 0.5, duration: 0.8 }}
                >
                    A once-a-year celebration of one very extraordinary human
                </motion.p>

                <h1 className="font-display leading-[0.95]">
                    {lines.map((l, i) => (
                        <span className="mask-line" key={l}>
                            <motion.span
                                className={`text-[15vw] font-semibold sm:text-[11vw] lg:text-[8.5rem] ${i === 2 ? "gold-text italic" : "text-[#FBF7EE]"}`}
                                initial={{ y: "115%" }}
                                animate={active ? { y: "0%" } : {}}
                                transition={{ delay: 0.7 + i * 0.16, duration: 1.05, ease: [0.22, 1, 0.36, 1] }}
                            >
                                {l}
                            </motion.span>
                        </span>
                    ))}
                </h1>

                <motion.p
                    className="mx-auto mt-8 max-w-md text-sm font-light text-[#C4B5FD]/85 sm:text-base"
                    initial={{ opacity: 0 }}
                    animate={active ? { opacity: 1 } : {}}
                    transition={{ delay: 1.7, duration: 0.9 }}
                >
                    Birthday Edition — 2026 · Crafted with questionable developer humour
                    and genuine appreciation, by Jerry at WebTechGuider
                </motion.p>
            </motion.div>

            <motion.div
                className="absolute bottom-8 left-1/2 z-[1] flex -translate-x-1/2 flex-col items-center gap-2"
                initial={{ opacity: 0 }}
                animate={active ? { opacity: 1 } : {}}
                transition={{ delay: 2.3, duration: 0.8 }}
            >
                <span className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-[#F3D085]/60">
                    Scroll to begin the ceremony
                </span>
                <motion.span animate={reduce ? {} : { y: [0, 7, 0] }} transition={{ repeat: Infinity, duration: 1.8 }}>
                    <ChevronDown className="h-4 w-4 text-[#F3D085]/70" />
                </motion.span>
            </motion.div>
        </section>
    );
}
